// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoData_noData__1MZ6U","pic":"NoData_pic__2RwYQ","text":"NoData_text__1a1EX"};